import axios from 'axios';
import useSWR from 'swr';

const DATA_KEY = 'solemti-address';

interface LocationData {
	_id: string;
	Codigo: string;
	Asentamiento: string;
	Municipio: string;
	Estado: string;
	Ciudad: string;
	Zona: string;
}

const solemtiAddressFetcher = async (args: { zipCode: string }) => {
	const { data } = await axios.post<LocationData[]>(
		'https://ms.solemti.net/address',
		{
			zipcode: args.zipCode,
		},
		{
			params: {
				langId: '-5',
			},
			headers: {
				'Content-Type': 'application/json',
			},
		}
	);

	return data;
};

export const useZipCode = (zipcode?: string) => {
	const {
		data = [],
		error,
		isLoading,
	} = useSWR(zipcode && zipcode?.length >= 5 ? [zipcode, DATA_KEY] : null, ([zipcode]) =>
		solemtiAddressFetcher({ zipCode: zipcode })
	);

	return { data, error, isLoading };
};

export default useZipCode;
